import { odataFetch } from "@/lib/odata-fetch";
import { QUADMGetAllMaterialDefinitionsForAllMaterialSpecificationTypes2 } from "@/odata/appu4dm/QAppU4DM";
import { useQuery } from "@tanstack/react-query";
import { bomKeys } from "./bom-keys";
import { useWorkOrderOperationId } from "../work-order/use-work-order-operation-id";
import { UADMGetAllMaterialDefinitionsForAllMaterialSpecificationTypesResponse } from "@/odata/appu4dm/AppU4DMModel";

export function useOperationBom() {
  const { workOrderOperationId } = useWorkOrderOperationId();
  const { data, ...query } = useQuery({
    queryKey: bomKeys.getOperation(
      workOrderOperationId?.WorkOrderOperation_Id!,
    ),
    queryFn: ({ meta }) =>
      fetchOperationBom(
        workOrderOperationId?.WorkOrderOperation_Id!,
        meta!.token!,
      ),
    enabled: ({ meta }) =>
      !!(workOrderOperationId?.WorkOrderOperation_Id! && meta?.token),
  });

  return {
    ...query,
    operationItems: data?.value ?? [],
  } as const;
}

export type OperationBomResponse =
  UADMGetAllMaterialDefinitionsForAllMaterialSpecificationTypesResponse;

async function fetchOperationBom(workerOrderOpId: string, token: string) {
  const path =
    new QUADMGetAllMaterialDefinitionsForAllMaterialSpecificationTypes2().buildUrl(
      {
        function: {
          Id: workerOrderOpId,
          Type: "WorkOrderOperation",
        },
      },
    );

  return odataFetch<OperationBomResponse>({ path, token });
}
